import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ["first", "rest", "toggle", "collapse"]

  connect() {
    this.load()
  }

  load() {
    const params = new URLSearchParams({ type: 'post' })
    Rails.ajax({
      type: 'GET',
      url: `/saved_searches/sidebar_list?${params.toString()}`,
      dataType: 'json',
      success: (data) => {
        if (this.hasFirstTarget){
          $(this.firstTarget).html(data.first_html || '')
        }
        if (this.hasRestTarget){
          $(this.restTarget).html(data.rest_html || '')
        }
        if (data.has_more) {
          if (this.hasToggleTarget) this.toggleTarget.classList.remove('d-none')
        } else {
          if (this.hasToggleTarget) this.toggleTarget.classList.add('d-none')
        }

        $(".saved-search-li").hover(function(){
          let savedSearchId = $(this).data("savedSearchId");
          $(".a-actions-saved-search-"+savedSearchId).removeClass("opacity-0").addClass("opacity-100");
          }, function(){
          let savedSearchId = $(this).data("savedSearchId");
          $(".a-actions-saved-search-"+savedSearchId).removeClass("opacity-100").addClass("opacity-0");
        });

        $(".edit-saved-search-link").click(function() {
          let savedSearchId = $(this).data('savedSearchId');
          $.ajax({
            type: "GET",
            url: "/saved_searches/"+savedSearchId+"/edit",
            dataType: "script"
          });    
        });
      },
      error: (_xhr, _status, _error) => {
        // optionally log in dev
      }
    })
  }
}
